export const backgroundoptions = [
	  { value: 'Deep Blue', label: 'Deep Blue', parm: 'background' },
	  { value: 'Flame', label: 'Flame', parm: 'background' },
	  { value: 'Light Blue', label: 'Light Blue', parm: 'background' },
	  { value: 'Pink', label: 'Pink', parm: 'background' },
	  { value: 'Sand', label: 'Sand', parm: 'background' },
	  { value: 'Sea Green', label: 'Sea Green', parm: 'background' },
	  { value: 'Yellow', label: 'Yellow', parm: 'background' },
	];